import React from 'react';
import { IonImg, IonText } from '@ionic/react';
import { SupportedPublicLocale } from '../types';
import appLogoLight from '../../../assets/images/app-logo-light.png';
import appLogoDark from '../../../assets/images/app-logo-dark.png';

interface PublicReportFallbackProps {
  locale: SupportedPublicLocale;
}

const translations = {
  en: {
    title: 'Otuvy Frontline',
    subtitle: 'Task management made simple',
    downloadApp: 'Download the App',
  },
  fr: {
    title: 'Otuvy Frontline',
    subtitle: 'La gestion des tâches simplifiée',
    downloadApp: "Télécharger l'application",
  },
};

const APP_STORE_URL = 'https://apps.apple.com/app/otuvy-frontline/id6461824661';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.otuvy.frontline';

const PublicReportFallback: React.FC<PublicReportFallbackProps> = ({ locale }) => {
  const t = translations[locale];
  const isDarkMode = document.body.classList.contains('dark');

  return (
    <div className="ion-padding d-flex flex-direction-column h-100 justify-center">
      {/* Logo */}
      <div className="ion-text-center ion-padding-vertical">
        <IonImg
          src={isDarkMode ? appLogoDark : appLogoLight}
          alt="Otuvy Frontline"
          className="margin-auto"
          style={{ height: '72px', width: 'auto' }}
        />
      </div>

      {/* Title and Subtitle */}
      <IonText color="primary">
        <h1 className="ion-text-center font-28 font-weight-600 no-margin-top small-margin-bottom">{t.title}</h1>
      </IonText>
      <IonText color="medium">
        <p className="ion-text-center font-18 no-vertical-margin">{t.subtitle}</p>
      </IonText>

      {/* App Store Badges */}
      <div className="ion-text-center ion-padding-vertical ion-margin-top">
        <p className="font-16 font-weight-500 small-margin-bottom">{t.downloadApp}</p>
        <div className="d-flex flex-direction-column align-center gap-sm">
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              style={{ height: '44px' }}
            />
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{ height: '64px' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicReportFallback;
